import { useState } from "react";
import s from "./button-copy-to-clipboard.module.scss";

interface ButtonCopyToClipboardProps {
  value: string;
}

const ButtonCopyToClipboard: React.FC<ButtonCopyToClipboardProps> = ({ value }) => {
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    if (value) {
      navigator.clipboard.writeText(value).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      });
    } 
  };

  return (
      <button
        type="button"
        className="ml-2 btn p-0"
        onClick={handleCopy}
        aria-label="Copy to clipboard"
        title="Copy to clipboard"
        style={{minWidth: 72}} // ensure button width doesn't change when "Copied!" message appears
      >
          {copied ? (
            <span className={s['copied-message']}>
              <i className={`bi bi-check2 ${s['color-green']}`}></i>
              Copied!
            </span>
          ) : (
          <span className="d-flex">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"/>
            </svg>
          </span>
          )}
      </button>
  )
}

export default ButtonCopyToClipboard;